import Model from '../orm/Model'
import User from './User'

export default class UserTile extends Model {

    static entity = 'user_tiles'

    static fields() {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            user: this.hasOne(User, 'user_id'),
            tileable_id: this.number(),
            tileable_type: this.string(),
            tileable: this.morphTo('tileable_id', 'tileable_type')
        }
    }

    static graphql = {
        addToDashboard: {
            type: 'addToDashboard',
            parameters: {
                tileable_id: 'Int!',
                tileable_type: 'String!'
            }
        },
        removeFromDashboard: {
            type: 'removeFromDashboard',
            parameters: {
                tileable_id: 'Int!',
                tileable_type: 'String!'
            }
        }
    }
}